import { asyncAddToCart } from '@/js/api/asyncAddToCart'
import { TOAST_TYPES } from '@/js/toast-messages/container/ToastMessages'

// see also: https://shopify.dev/docs/api/ajax/reference/cart#post--locale-cart-addjs
class AddToCart {
    static SELECTORS = {
        button: '[data-add-to-cart]'
    }

    static CLASSES = {
        addToCart: 'button--add-to-cart',
        error: 'button--error',
        success: 'button--success'
    }

    $elements = {
        button: null,
        cartButton: null
    };
    productId = null;

    constructor(button) {
        this.$elements.button = button;
        this.$elements.cartButton = document.querySelector('cart-button');

        this.$elements.button.classList.add(AddToCart.CLASSES.addToCart)

        this.productId = this.$elements.button.dataset.addToCart;

        this.$elements.button.addEventListener('click', this.handleClick.bind(this))
    }

    /**
     * API
     */
    async addToCart(id, onSuccess) {
        this.isAddingToCart = true;

        const items = [];
        items.push({ id, quantity: 1 })



        try {
            const response = await asyncAddToCart(items)

            if (response.ok) {
                onSuccess && onSuccess(response)
            }

            return response
        } catch (error) {
            throw new Error('Failed to add item to cart')
        } finally {
            this.isAddingToCart = false;
        }
    }

    /**
     * METHODS
     */
    disableButton() {
        this.$elements.button.disabled = true;
    }

    enableButton() {
        this.$elements.button.disabled = false;
    }

    async submitAddToCart(id, onSuccess) {
        this.disableButton();

        const response = await this.addToCart(id, onSuccess)

        if (response.ok) {
            // all good
        } else {
            // 422 may mean: maximum allowed quantity reached, product is out of stock, etc.
            if (response.status && response.status === 422) {
                window.dispatchEvent(new CustomEvent('toast', { detail: {
                    message: 'Von diesem Produkt können keine weiteren in den Warenkorb gelegt werden.',
                    type: TOAST_TYPES.cartAdded,
                } }));

                this.enableButton();
            }
        }

        this.enableButton();
    }

    /**
     * EVENTS
     */
    handleClick(e) {
        e.preventDefault()

        this.submitAddToCart(this.productId, () => {
            window.dispatchEvent(new CustomEvent('toast', { detail: {
                message: 'Das Produkt wurde dem Warenkorb hinzugefügt!',
                type: TOAST_TYPES.cartAdded,
            } }));
            this.$elements.cartButton.increaseCounterBy(1)
        })
    }
}

const addToCartButtons = document.querySelectorAll(AddToCart.SELECTORS.button)

addToCartButtons.forEach(button => new AddToCart(button))